const user = {
  state: {
    userInfo: JSON.parse(
      localStorage.getItem("userInfo") != "undefined"
        ? localStorage.getItem("userInfo")
        : ""
    ), 
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit("SET_USERINFO", userInfo);
    },
  },
};
export default user;
